import { t } from 'ttag'
import { useMutation } from 'react-query'
import { useEffect, useMemo, useState } from 'react'

import { api, errors } from '@h2/api'
import { useForm } from '@h2/common/components/hooks/useForm'
import { Flex } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Button } from '@h2/components/buttons/button'
import { Field } from '@h2/components/inputs/field'
import { Select } from '@h2/components/inputs/select'
import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'

const ReassignmentActionsContent = ({ assignmentId, toggleModal, onSuccess }) => {
  const [assignees, setAssignees] = useState([]) //useSelector(state => state.fileManagementWizard.data.tags)

  useEffect(() => {
    const getAssignees = async () => {
      const possibilities = await api.fetch(
        '/management/assignments/ownership/listpotential'
      )

      setAssignees(possibilities)
    }

    getAssignees()
  }, [])

  const {
    register: registerApprovalForm,
    isInvalid: isInvalidApprovalForm,
    handleOnSubmit: handleOnSubmitApprovalForm,
    dispatch: dispatchApprovalForm,
    error
  } = useForm({
    navigator(form) {
      if (!form.navigator) {
        return t`You must specify a navigator to proceed`
      }
    }
  })
  const { mutate: mutateApproval, isLoading: isApprovalLoading } = useMutation(
    body => {
      return api.fetch(`/management/assignments/ownership/${assignmentId}`, {
        method: 'PUT',
        body: JSON.stringify({ newOwnerId: body.navigator.value })
      })
    },
    {
      onSuccess: assignmentResponse => {
        assignmentResponse.affectedPlans.forEach(assignment => onSuccess(assignment))
        toggleModal()
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatchApprovalForm({ type: 'validate', payload: formErrors })
        }
      }
    }
  )
  const assigneesMemo = useMemo(() => {
    return assignees.map(assignee => ({
      label: assignee.name,
      value: assignee.id
    }))
  }, [assignees])

  return (
    <div>
      <Text>{t`If you wish to reassign this assignment to a different Navigator, please select their name from the list below.`}</Text>
      <form onSubmit={handleOnSubmitApprovalForm(form => mutateApproval(form))}>
        <Field
          label={t`Select Navigator:`}
          desc={error.navigator}
          htmlFor="assignees"
          status={error.navigator ? 'error' : 'default'}>
          <Select
            id="assignees"
            items={assigneesMemo}
            {...registerApprovalForm('navigator', { required: true })}
          />
        </Field>
        <Flex justifyContent="space-between">
          <Box width="250px">
            <Button
              type="submit"
              size="large"
              align="center"
              isLoading={isApprovalLoading}
              isDisabled={isApprovalLoading || isInvalidApprovalForm}>
              {t`Reassign`}
            </Button>
          </Box>
        </Flex>
      </form>
    </div>
  )
}
const ReassignmentActions = ({ assignmentId, isOpen, toggleModal, onSuccess }) => {
  return (
    <Modal isOpen={isOpen} closeOnClickOverlay={true} onClose={toggleModal}>
      <Modal.Header>
        <Heading level="3">{t`Reassign`}</Heading>
      </Modal.Header>
      <Modal.Body>
        <ReassignmentActionsContent
          assignmentId={assignmentId}
          toggleModal={toggleModal}
          onSuccess={onSuccess}
        />
      </Modal.Body>
    </Modal>
  )
}

export { ReassignmentActions }
